import { getIsSection } from '@unifyapps/carbon/widgets/SchemaGeneratorWidget/utils/canNodeHaveChild';
import type { JSONSchema7WithForeignKey } from '@unifyapps/carbon/no-code/utils/dataSourceLookup/types';

export const shouldTraverseSchema = ({
  schema,
}: {
  schema: JSONSchema7WithForeignKey;
}): boolean => {
  return getIsSection(schema);
};
